module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "darkest",
    class: {
      'pointer': _vm.notification.metadata && _vm.notification.metadata.pendingReservation
    },
    domProps: {
      "innerHTML": _vm._s(_vm.notification.message)
    },
    on: {
      "click": _vm.openReservation
    }
  }), _vm._v(" "), (_vm.showInvoiceBtn) ? _c('button', {
    staticClass: "btn tertiary narrow my-1",
    on: {
      "click": _vm.openReservation
    }
  }, [_vm._v("View booking")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c443711c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/notifications/bodyReservationPending.vue
// module id = 2071
// module chunks = 0